import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  gender: '',
  maritalStatus: '',
  fatherName: '',
  motherName: '',
  countryOfBirth: '',
  cityOfBirth: '',
  nationalityID: '',
  passportNumber: '',
  secondNationality: '',
};

export const getInputs = (
  values: IPersonAdditionalInformationInfo = initialValues,
  lovs: Record<string, Record<string, string>>,
  type: string
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      gender: {
        name: 'gender',
        title: 'Gender',
        type: FormFieldType.select,
        placeholder: 'Gender',
        value: !isEmpty(values.gender) ? values.gender : null,
        hidden: false,
        disabled: false,
        selectOptions: lovs.genders || {},
      },
      maritalStatus: {
        name: 'maritalStatus',
        title: 'Marital Status',
        placeholder: 'Marital Status',
        type: FormFieldType.select,
        value: !isEmpty(values.maritalStatus) ? values.maritalStatus : null,
        hidden: false,
        disabled: false,
        selectOptions: lovs.maritalStatuses || {},
      },
      fatherName: {
        name: 'fatherName',
        title: 'Father Name',
        placeholder: 'Father Name',
        type: FormFieldType.text,
        value: values.fatherName,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false,
      },
      motherName: {
        name: 'motherName',
        title: 'Mother Name',
        placeholder: 'Mother Name',
        type: FormFieldType.text,
        value: values.motherName,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false,
      },
      countryOfBirth: {
        name: 'countryOfBirth',
        title: 'Country of Birth',
        placeholder: 'Country of Birth',
        type: FormFieldType.select,
        value: !isEmpty(values.countryOfBirth) ? values.countryOfBirth : null,
        hidden: false,
        disabled: false,
        selectOptions: lovs.countries,
      },
      cityOfBirth: {
        name: 'cityOfBirth',
        title: 'City of Birth',
        placeholder: 'City of Birth',
        type: FormFieldType.text,
        value: values.cityOfBirth,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false,
      },
      nationalityID: {
        name: 'nationalityID',
        title: 'Nationality ID',
        placeholder: 'Nationality ID',
        type: FormFieldType.text,
        value: values.nationalityID,
        minCharacters: 2,
        maxCharacters: 100,
      },
      passportNumber: {
        name: 'passportNumber',
        title: 'Passport Number',
        type: FormFieldType.text,
        placeholder: 'Passport Number',
        value: values.passportNumber,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false,
      },
      secondNationality: {
        name: 'secondNationality',
        title: 'Second Nationality',
        type: FormFieldType.select,
        placeholder: 'Second Nationality',
        value: !isEmpty(values.secondNationality)
          ? values.secondNationality
          : null,
        selectOptions: lovs.nationalities,
      },
    },
  },
];
